import { useEffect } from 'react'

const HealthCheck = () => {
    useEffect(() => {
        const healthData = {
            status: 'healthy',
            timestamp: new Date().toISOString(),
            uptime: 0 // Browser'da process.uptime() yok
        }

        // Clear body and set styles
        document.body.innerHTML = ''
        document.body.style.margin = '0'
        document.body.style.padding = '0'

        // Create pre element for JSON display
        const pre = document.createElement('pre')
        pre.style.fontFamily = 'monospace'
        pre.style.padding = '20px'
        pre.style.whiteSpace = 'pre-wrap'
        pre.style.margin = '0'
        pre.textContent = JSON.stringify(healthData, null, 2)

        document.body.appendChild(pre)
    }, [])

    return null
}

export default HealthCheck

